import checkResponse from "./checkResponse";

// checkResponse for a finished XMLHttpRequest. One that never completed has status 0 and no
// `responseURL`, so `url` names the request in its place.
export default function checkXhr(xhr, { method = "GET", url = "", expectsJson = false, silent = false } = {}) {
  return checkResponse({
    method: method.toUpperCase(),
    url: xhr.responseURL || url,
    status: xhr.status,
    header: (name) => xhr.getResponseHeader(name),
    readBody: () => xhr.responseText,
    expectsJson,
    silent,
  });
}
